import { createTypes } from 'redux-action-creator';
import { Action } from '../../../types';
import { WaiverWorkItemSearchCriteria } from '../../../../types/waiverWorkItem';

export const types: { [key: string]: string } = createTypes(
  ['LOAD_SUCCESS'],
  'WORK_ITEM_SEARCH_CRITERIA',
);

export function receiveSearchCriteria(
  criteria: WaiverWorkItemSearchCriteria,
): Action<WaiverWorkItemSearchCriteria> {
  return {
    type: types.LOAD_SUCCESS,
    response: criteria,
  };
}
